"use strict";

const buildTimeHrUrlPrefix = process.env.HR_URL_PREFIX;

function runtimePrefix() {
    if (typeof globalThis === "undefined") {
        return undefined;
    }

    if (typeof globalThis.HR_URL_PREFIX === "string") {
        return globalThis.HR_URL_PREFIX;
    }

    return globalThis.process?.env?.HR_URL_PREFIX;
}

export const hrUrlPrefix = runtimePrefix() ?? buildTimeHrUrlPrefix ?? "";
